import { NewFeedPictureModel } from "../../newfeeds/models/NewFeedModel";
import {
    CollageLayoutManager, PhotoCollageStyle, PhotoSize
} from "../models/PhotoCollageModel";
import { CollageProps } from "./TwoPhotoView";

export default function FivePhoto({ photos, photoManager, layout }: CollageProps) {
    const layoutManager = new CollageLayoutManager(layout);

    const style = new PhotoCollageStyle(
        photoManager.dimension.getSpacing(),
        layoutManager.isTall()
    );

    const smallStyle: React.CSSProperties = {
        display: style.innerDisplay,
        paddingBottom: style.paddingBottom,
        paddingRight: style.paddingRight
    };

    const large = (photo: NewFeedPictureModel): JSX.Element => {
        return <>
            {photoManager.getSquare(photo, PhotoSize.half)}
        </>;
    }

    const small = (photo: NewFeedPictureModel): JSX.Element => {
        const isTall = layoutManager.isTall();

        return <>
            {photoManager.getRectangle(
                photo,
                isTall ? PhotoSize.half : PhotoSize.oneThird,
                PhotoSize.oneThird,
                isTall
            )}
        </>;
    }

    return <div style={{ display: "inline-block" }}>
        <div style={{
            float: style.outerFloat,
            paddingRight: style.paddingBottom,
            paddingBottom: style.paddingRight
        }}>
            <div style={smallStyle}>{large(photos[0])}</div>
            <div style={smallStyle}>{large(photos[1])}</div>
        </div>
        <div style={{ float: style.innerFloat }}>
            <div style={smallStyle}>{small(photos[2])}</div>
            <div style={smallStyle}>{small(photos[3])}</div>
            <div style={smallStyle}>{small(photos[4])}</div>
        </div>
    </div>;
}